import { render, staticRenderFns } from "./ApplicantShowKnowledge.vue?vue&type=template&id=45bc35ed&"
import script from "./ApplicantShowKnowledge.vue?vue&type=script&lang=js&"
export * from "./ApplicantShowKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports